(function ($) {
  var MOBILE_BREAKPOINT = 750;
  var RESIZE_DEBOUNCE_MS = 120;
  var moreMenuCounter = 0;
  var resizeTimer = null;

  function closeMoreMenus() {
    $('.header-bottom [data-header-bottom-more-item] .mega-menu__content').removeClass('is-open');
    $('.header-bottom [data-header-bottom-more-item] .header__menu-item.more_menu').attr('aria-expanded', 'false');
  }

  function hasWrappedItems(listElement) {
    if (!listElement) {
      return false;
    }

    var children = Array.prototype.slice.call(listElement.children || []);
    if (!children.length) {
      return false;
    }

    var firstTop = children[0].offsetTop;
    for (var i = 1; i < children.length; i += 1) {
      if (children[i].offsetTop > firstTop + 1) {
        return true;
      }
    }

    return false;
  }

  function isOverflowing(listElement) {
    if (!listElement) {
      return false;
    }

    return listElement.scrollWidth > listElement.clientWidth + 2 || hasWrappedItems(listElement);
  }

  function getMoreLabel($scope) {
    var label = $.trim($scope.find('#moremenu_text').first().text());
    return label || 'More';
  }

  function cacheOriginalItems($list) {
    if ($list.data('headerBottomOriginalItems')) {
      return;
    }
    var originalItems = $list.children('li').not('[data-header-bottom-more-item]').toArray();
    $list.data('headerBottomOriginalItems', originalItems);
  }

  function restoreOriginalItems($list) {
    var originalItems = $list.data('headerBottomOriginalItems');
    if (!originalItems || !originalItems.length) {
      return;
    }

    $list.children('li[data-header-bottom-more-item]').remove();
    closeMoreMenus();

    for (var i = 0; i < originalItems.length; i += 1) {
      $list.append(originalItems[i]);
    }
  }

  function createMoreMenu(label) {
    moreMenuCounter += 1;
    var moreId = 'Details-HeaderMenu-moremenu-' + moreMenuCounter;
    var caretSvg = '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>';

    var $moreItem = $('<li data-header-bottom-more-item></li>');
    var $headerMenu = $('<header-menu></header-menu>');
    var $mega = $('<span class="mega-menu"></span>').attr('id', moreId);
    var $trigger = $('<span class="header__menu-item list-menu__item link focus-inset more_menu" role="button" tabindex="0" aria-haspopup="true" aria-expanded="false"></span>');
    $trigger.append($('<span></span>').text(label));
    $trigger.append(caretSvg);

    var $content = $('<div class="mega-menu mega-menu__content gradient global-settings-popup"><ul class="mega-menu__list page-width" role="list"></ul></div>');
    $mega.append($trigger);
    $mega.append($content);
    $headerMenu.append($mega);
    $moreItem.append($headerMenu);

    return {
      item: $moreItem,
      list: $content.find('ul').first()
    };
  }

  function applyMoreMenu($list, $scope) {
    cacheOriginalItems($list);
    restoreOriginalItems($list);

    if (window.innerWidth < MOBILE_BREAKPOINT) {
      return;
    }

    var listElement = $list.get(0);
    var originalItems = $list.data('headerBottomOriginalItems') || [];
    if (!listElement || originalItems.length < 2) {
      return;
    }

    if (!isOverflowing(listElement)) {
      return;
    }

    var moreMenu = createMoreMenu(getMoreLabel($scope));
    $list.append(moreMenu.item);

    for (var index = originalItems.length - 1; index > 0 && isOverflowing(listElement); index -= 1) {
      moreMenu.list.prepend(originalItems[index]);
    }

    if (!moreMenu.list.children().length) {
      moreMenu.item.remove();
    }
  }

  function rebuildHeaderMenus() {
    $('.header-bottom').each(function () {
      var $scope = $(this);
      $scope.find('.header__inline-menu .list-menu.list-menu--inline').each(function () {
        applyMoreMenu($(this), $scope);
      });
    });
  }

  function bindEvents() {
    $('#menu-drawer .icon.icon-close, .category_overlay').on('click', function () {
      $('#Details-menu-drawer-container.menu-drawer-container').removeClass('menu-opening');
      $('body').removeClass('overflow-hidden-undefined overflow-hidden-tablet');
      $('#Details-menu-drawer-container .header__icon--menu').attr('aria-expanded', 'false');
      $('#Details-menu-drawer-container.menu-drawer-container').removeAttr('open');
    });

    $(window).on('resize orientationchange', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        closeMoreMenus();
        window.requestAnimationFrame(function () {
          rebuildHeaderMenus();
          window.requestAnimationFrame(rebuildHeaderMenus);
        });
      }, RESIZE_DEBOUNCE_MS);
    });

    $(document).on('click', '.header-bottom [data-header-bottom-more-item] .header__menu-item.more_menu', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var $trigger = $(this);
      var $menuContent = $trigger.siblings('.mega-menu__content');
      var willOpen = !$menuContent.hasClass('is-open');
      closeMoreMenus();
      if (willOpen) {
        $menuContent.addClass('is-open');
        $trigger.attr('aria-expanded', 'true');
      }
    });

    $(document).on('keydown', '.header-bottom [data-header-bottom-more-item] .header__menu-item.more_menu', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        $(this).trigger('click');
      }
      if (event.key === 'Escape') {
        closeMoreMenus();
      }
    });

    $(document).on('click', function (event) {
      if (!$(event.target).closest('.header-bottom [data-header-bottom-more-item]').length) {
        closeMoreMenus();
      }
    });

    document.addEventListener('shopify:section:load', function () {
      window.setTimeout(rebuildHeaderMenus, 0);
    });

    $(window).on('load', rebuildHeaderMenus);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(rebuildHeaderMenus);
    }
  }

  $(document).ready(function () {
    bindEvents();
    rebuildHeaderMenus();
  });
})(jQuery);
